var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex flex-column flex-root"
  }, [_vm.isAuthenticated && _vm.empresaId ? _c('CatalogoDigitalOrderPoller', {
    key: _vm.empresaId,
    attrs: {
      "empresa-id": _vm.empresaId
    }
  }) : _vm._e(), _c('router-view')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };